import { Navigate, Outlet } from 'react-router-dom';
import ROUTES from './RoutePath';

const PrivateRoutes = () => {

  let auth = sessionStorage.getItem("JsonWebToken");
  return (auth ? <Outlet /> : <Navigate to={ROUTES.MAIN_ROUTE}/>)
};

export default PrivateRoutes;